import { useOperation } from '../../../types/Operation.mjs';

// -----------------
// Operation
// -----------------

const Key = 'GetBuyerBalanceOperation';

/**
 * Gets the balance of a buyer's escrow account for a given Auction House.
 *
 * ```ts
 * await metaplex
 *   .auctionHouse()
 *   .getBuyerBalance({ auctionHouse, buyerAddress };
 * ```
 *
 * @group Operations
 * @category Constructors
 */
const getBuyerBalanceOperation = useOperation(Key);

/**
 * @group Operations
 * @category Types
 */

/**
 * @group Operations
 * @category Handlers
 */
const getBuyerBalanceOperationHandler = {
  handle: async (operation, metaplex, scope) => {
    const {
      auctionHouse,
      buyerAddress
    } = operation.input;
    const buyerEscrow = metaplex.auctionHouse().pdas().buyerEscrow({
      auctionHouse,
      buyer: buyerAddress,
      programs: scope.programs
    });
    return metaplex.rpc().getBalance(buyerEscrow, scope.commitment);
  }
};

export { getBuyerBalanceOperation, getBuyerBalanceOperationHandler };
//# sourceMappingURL=getBuyerBalance.mjs.map
